import React from "react";

export const sortCaret = (order, _column) => {
  if (!order) return (
    <span className="th-sort" aria-hidden="true">
      {/* Show Nothing */}
    </span>
  );
  else if (order === "asc")
    return (
      <span className="th-sort th-sort-asc icon-sorting-up" aria-hidden="true"></span>
    );
  else if (order === "desc")
    return (
      <span className="th-sort th-sort-desc icon-sorting-down" aria-hidden="true"></span>
    );
  return null;
};

export const headerSortingClasses = (_column, sortOrder, _isLastSorting, _colIndex) => (
  (sortOrder === 'asc' || sortOrder === "desc") ? 'sortable-active' : ''
);